import Flatpickr from "stimulus-flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

const locales = {
  fr: French,
  es: Spanish,
  pt: Portuguese,
};

export default class extends Flatpickr {
  initialize() {
    const lang = document.documentElement.lang || "fr";
    this.config = {
      ...(locales[lang] && { locale: locales[lang] }),
    };
  }
}
